const Images = {
  arrowDown: require('../assets/icons/arrow-down.svg'),
  bake: require('../assets/icons/bake.png'),
  cookie: require('../assets/icons/cookie.svg'),
  cooking: require('../assets/icons/cooking.png'),
  email: require('../assets/icons/email.svg'),
  google: require('../assets/icons/google.svg'),
  instagram: require('../assets/icons/instagram.svg'),
  linkedin: require('../assets/icons/linkedin.svg'),
  logo: require('../assets/icons/logo.png'),
  password: require('../assets/icons/password.svg'),
  save: require('../assets/icons/save.svg'),
  twitter: require('../assets/icons/twitter.svg'),
  userAvatar: require('../assets/icons/user-avatar.png'),
  userForInput: require('../assets/icons/user-for-input.svg'),
  user: require('../assets/icons/user.svg'),
  user2: require('../assets/icons/user2.svg'),
  view: require('../assets/icons/view.svg'),
  water: require('../assets/icons/water.png'),
  womanAvatar: require('../assets/icons/woman-avatar.png'),
  addRecipes: require('../assets/imgs/addRecipes.jpg'),
  articleTop: require('../assets/imgs/article-top.png'),
  azian: require('../assets/imgs/asian.png'),
  baking: require('../assets/imgs/baking.png'),
  bg: require('../assets/imgs/bg.svg'),
  cheesecake: require('../assets/imgs/cheesecake.jpeg'),
  cookies: require('../assets/imgs/cookies.png'),
  dessert: require('../assets/imgs/dessert.jpeg'),
  heroImg: require('../assets/imgs/hero-img.png'),
  impact: require('../assets/imgs/impact.jpg'),
  junkfood: require('../assets/imgs/junkfood.jpg'),
  pasta: require('../assets/imgs/pasta.jpg'),
  pizza: require('../assets/imgs/pizza.jpg'),
  singUp: require('../assets/imgs/singUp.jpeg'),
  stirFry: require('../assets/imgs/stir-fry.jpg'),
  subscribe: require('../assets/imgs/subscribe.jpg'),
  vegeterian: require('../assets/imgs/vegeterian.jpg'),
  edit: require('../assets/icons/edit.svg'),
  delete: require('../assets/icons/remove.svg'),
  calendar: require('../assets/icons/calendar.svg'),
  views: require('../assets/icons/view2.svg'),
  share: require('../assets/icons/share.svg'),
  remove: require('../assets/icons/remove.svg'),
  box: require('../assets/icons/checkbox.svg'),
  checkbox: require('../assets/icons/checkbox-check.svg'),
  menu: require('../assets/icons/menu.svg').default,
  close: require('../assets/icons/close.svg').default,
}
export default Images;